import { Animated as AnimatedBase } from 'react-animated-css';
import React from 'react';

// Type wrapper for react-animated-css (unmaintained package with outdated types for React 18)
const Animated = AnimatedBase as React.ComponentType<{
  children?: React.ReactNode;
  animationIn?: string;
  animationOut?: string;
  animationInDuration?: number;
  animationOutDuration?: number;
  animationInDelay?: number;
  animationOutDelay?: number;
  isVisible?: boolean;
  animateOnMount?: boolean;
  style?: React.CSSProperties;
  className?: string;
}>;

export default Animated;
